import React from 'react'
import { useSummaryFormContext } from '../hook/summary-form'
import { Paper, Text, Divider, SimpleGrid, NumberInput } from '@mantine/core'

const SummaryAdditionalData = () => {
  const form = useSummaryFormContext()

  return (
    <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
      <Text fw={500}>
        Additional Data
      </Text>

      <Divider my={10} />

      <SimpleGrid cols={4} spacing="xl" verticalSpacing="xl">
        <NumberInput
          label='Base QTY Review'
          key={form.key('base_qty_review')}
          {...form.getInputProps('base_qty_review')}
          rightSection={<Text fz={12} c='black' tt='capitalize'>reviews</Text>}
          rightSectionWidth={60}
        />

        <NumberInput
          label="Base Average Review Point"
          rightSection={<Text fz={12} c='black' tt='capitalize'>/5</Text>}
          rightSectionWidth={40}
          key={form.key('base_average_review_point')}
          {...form.getInputProps('base_average_review_point')}
          min={0}
          max={5}
          clampBehavior="strict"
        />

        <NumberInput
          label="Base Qty Sold"
          rightSection={<Text fz={12} c='black' tt='capitalize'>{form.values.quantity_unit}</Text>}
          rightSectionWidth={50}
          key={form.key('base_qty_sold')}
          {...form.getInputProps('base_qty_sold')}
        />

        <NumberInput
          label='Asiacommerce Poin'
          description="Points that users get when purchasing this product"
          rightSection={<Text fz={12} c='black' tt='capitalize'>point</Text>}
          rightSectionWidth={40}
          key={form.key('reward_point')}
          {...form.getInputProps('reward_point')}
          min={0}
          max={100}
          clampBehavior="strict"
          inputWrapperOrder={['label', 'input', 'description', 'error']}
        />
      </SimpleGrid>
    </Paper>
  )
}

export default SummaryAdditionalData